import type { TFunction } from 'i18next';
import { array, string } from 'yup';

import { UserPersonas } from 'src/shared/graphql/generated';

export const makeName = (t: TFunction) =>
  string()
    .required(t('onboarding.pleaseProvideName'))
    .min(2, t('onboarding.nameMustBeAtLeast'))
    .max(255, t('onboarding.nameTooLong')); // https://github.com/hoverinc/hyperion/blob/7e6672c38d1d32893e228416c411f4dbcc9849f4/db/schema.rb#L1969

export const makeEmail = (t: TFunction) =>
  string()
    .required(t('onboarding.emailIsRequired'))
    .email(t('onboarding.pleaseEnterAValidEmail'))
    .matches(
      /^[^@\s]+@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i,
      t('onboarding.pleaseEnterAValidEmail'),
    );

export enum OrgConstructionDescriptions {
  RESTORATION_AND_MITIGATION = 'Mitigation / Remediation',
  CONTRACTOR = 'Contractor',
  CUSTOM_HOME_BUILDER = 'Custom Home Builder',
  ARCHITECT_ENGINEER = 'Architect / Engineer',
  DESIGNER = 'Designer',
  DISTRIBUTOR = 'Distributor',
  MANUFACTURER = 'Manufacturer',
}

export enum OrgInsuranceDescriptions {
  NATIONAL_CARRIER = 'National Carrier',
  REGIONAL_CARRIER = 'Regional Carrier',
  FULL_SERVICE_ADJUSTING_FIRM = 'Full Service Adjusting Firm',
  THIRD_PARTY_LADDER_ASSIST_FIRM = '3rd Party Ladder Assist Firm',
  INDEPENDENT_ADJUSTER = '1099 Independent Adjuster / Inspector',
  PUBLIC_ADJUSTING_FIRM = 'Public Adjusting Firm',
  UNDERWRITING_INSPECTOR = 'Underwriting Inspector',
}
const validDescriptions = [
  ...Object.values(OrgConstructionDescriptions),
  ...Object.values(OrgInsuranceDescriptions),
];

export const makeOrgDescription = () =>
  array().required().of(string().required().oneOf(validDescriptions));

export const makePersona = () =>
  array()
    .required()
    .of(string().required().oneOf(Object.values(UserPersonas)));
